import {
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTranslation } from 'react-i18next';
import { formatOpeningTime, normalizeOpeningPeriods } from '../../utils/openingHours';

export default function OpeningHoursDialog({ open, openingHours, onClose }) {
  const { t } = useTranslation();
  const periods = normalizeOpeningPeriods(openingHours);
  const today = new Date().getDay();
  const days = Array.from({ length: 7 }, (_, day) => ({
    day,
    periods: periods.filter((period) => period.day === day),
  }));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      slotProps={{
        backdrop: { sx: { bgcolor: 'rgba(0,0,0,.08)', backdropFilter: 'blur(2px)' } },
        paper: {
          sx: {
            width: 340, maxWidth: 'calc(100vw - 20px)', maxHeight: 'calc(100dvh - 20px)',
            m: { xs: 1.25, sm: 2 }, mb: { xs: 1.25, sm: 30 }, p: 0.6,
            border: '1px solid', borderColor: 'divider', borderRadius: '20px',
            bgcolor: 'background.paper', backgroundImage: 'none',
            boxShadow: '0 18px 55px rgba(0,0,0,.18)',
          },
        },
      }}
    >
      <Stack direction="row" sx={{ px: 1.2, py: 1, alignItems: "center", justifyContent: "space-between" }}>
        <Stack direction="row" alignItems="center" spacing={0.9}>
          <AccessTimeRoundedIcon color="primary" sx={{ fontSize: 22 }} />
          <Typography component="h2" fontSize={18} fontWeight={800}>
            {t('openingHours.title')}
          </Typography>
        </Stack>

        <IconButton size="small" onClick={onClose} aria-label={t('place.close')}>
          <CloseRoundedIcon />
        </IconButton>
      </Stack>

      <DialogContent sx={{ p: '0 5px 5px !important', overflowY: 'auto' }}>
        {days.map(({ day, periods: dayPeriods }) => (
          <Stack
            key={day}
            direction="row"

            sx={{
              justifyContent: "space-between",
              alignItems: "flex-start",
              minHeight: 42, px: 1.1, py: 1.15,
              borderTop: '1px solid', borderColor: 'divider',
              borderRadius: day === today ? '10px' : 0,
              bgcolor: day === today ? 'rgba(90,200,59,.11)' : 'transparent',
            }}
          >
            <Typography sx={{ width: 76, flex: '0 0 auto', fontSize: 14, fontWeight: 800 }}>
              {t(`openingHours.days.${day}`)}
            </Typography>
            <Stack spacing={0.3} alignItems="flex-end">
              {!dayPeriods.length ? (
                <Typography color="text.secondary" fontSize={13}>
                  {t('openingHours.closed')}
                </Typography>
              ) : dayPeriods.map((period, index) => (
                <Typography key={`${day}-${index}`} color="text.secondary" fontSize={13}>
                  {period.isOpen24Hours
                    ? t('openingHours.open24Hours')
                    : `${formatOpeningTime(period.start)} - ${formatOpeningTime(period.end)}`}
                </Typography>
              ))}
            </Stack>
          </Stack>
        ))}
      </DialogContent>
    </Dialog>
  );
}
